import { Item as BasketItem } from '../../weborder/BasketControl';
import { MenuItem, MenuItemOptionSetItem } from '../api/menu/menu.types';

// #region selector types
export type BasketItemType = {
  index: number;
  item: MenuItem;
  options: MenuItemOptionSetItem[];
  quantity: number;
};

export interface SummarisedBasketItems {
  [index: string]: BasketItemType;
}
// #endregion

// #region hook types
export enum BasketSource {
  CheckoutBasket = 'Checkout Basket',
  CheckoutCrossSell = 'Checkout Cross-sell',
  MenuBasket = 'Menu Basket',
  MenuCards = 'Menu Cards',
  MenuCrossSellDialog = 'Menu Cross-sell Dialog',
  MenuItemDetailDialog = 'Menu Item Detail Dialog',
  MenuSearch = 'Menu Search',
  OrderConfirmation = 'Order Confirmation',
}

export interface AddItemHookPayload {
  item: MenuItem;
  options?: MenuItemOptionSetItem[];
  quantity?: number;
  source: BasketSource;
}

export interface RemoveItemHookPayload {
  index?: number;
  item: MenuItem;
  source: BasketSource;
}
// #endregion

// #region action types
export type AddItemPayloadType = BasketItem;

export interface RemoveItemPayloadType {
  index: number;
  indexName: string;
  menuId: number;
}
// #endregion
